import React, { useState } from 'react';
import {
  Button,
  Snackbar,
} from '@mui/material';
import ShareIcon from '@mui/icons-material/Share';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import XIcon from '@mui/icons-material/X';
import ImageIcon from '@mui/icons-material/Image';
import PopoverMenu from '../common/PopoverMenu';

interface GotyShareMenuProps {
  username: string;
  year: number;
  isMyGoty: boolean;
  displayName: string;
  gameName?: string;
  onThumbnailClick: () => void;
  showThumbnailOption?: boolean;
}

const GotyShareMenu: React.FC<GotyShareMenuProps> = ({
  username,
  year,
  isMyGoty,
  displayName,
  gameName,
  onThumbnailClick,
  showThumbnailOption = true
}) => {
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const url = isMyGoty ? `/mygoty/${year}/${username}` : `/goty/${year}/${username}`;
  const fullUrl = `${process.env.REACT_APP_FRONTEND_URL}${url}`;
  const gameText = gameName ? `\n🏆${gameName}` : '';
  const shareText = `${displayName}'s ${isMyGoty ? 'MyGOTY' : 'GOTY'} ${year} | PULSE${gameText}`;

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCopyLink = () => {
    navigator.clipboard.writeText(fullUrl);
    setOpenSnackbar(true);
    handleClose();
  };

  const handleShareX = () => {
    const xShareUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}&url=${encodeURIComponent(fullUrl)}&hashtags=${encodeURIComponent('PULSE_DB,GOTY')}`;
    window.open(xShareUrl, '_blank');
    handleClose();
  };

  const handleThumbnail = () => {
    onThumbnailClick();
    handleClose();
  };

  const menuOptions = [
    ...(showThumbnailOption ? [{
      icon: <ImageIcon />,
      label: 'サムネイル画像を生成',
      onClick: handleThumbnail
    }] : []),
    {
      icon: <XIcon />,
      label: 'Xでシェア',
      onClick: handleShareX
    },
    {
      icon: <ContentCopyIcon />,
      label: 'URLをコピー',
      onClick: handleCopyLink
    }
  ];

  return (
    <>
      <Button
        onClick={handleClick}
        variant="outlined"
        startIcon={<ShareIcon />}
        sx={{
          px: 3,
          py: 1,
          borderRadius: 2,
          borderColor: 'rgba(255, 255, 255, 0.2)',
          backgroundColor: 'transparent',
          color: 'rgba(255, 255, 255, 0.7)',
          textTransform: 'none',
          fontSize: '0.9rem',
          fontWeight: 500,
          '&:hover': {
            borderColor: 'rgba(102, 126, 234, 0.8)',
            backgroundColor: 'rgba(102, 126, 234, 0.15)',
            color: 'rgba(102, 126, 234, 1)'
          }
        }}
      >
        共有する
      </Button>

      <PopoverMenu
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        title="共有オプション"
        options={menuOptions}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      />

      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={() => setOpenSnackbar(false)}
        message="URLをコピーしました"
      />
    </>
  );
};

export default GotyShareMenu;
